/* tslint:disable */
/* eslint-disable */
/**
 * SLOeats API
 * Interal API to the SLOeats platform.
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReferralCodeValidation
 */
export interface ReferralCodeValidation {
    /**
     * 
     * @type {string}
     * @memberof ReferralCodeValidation
     */
    referral_code: string;
}

/**
 * Check if a given object implements the ReferralCodeValidation interface.
 */
export function instanceOfReferralCodeValidation(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "referral_code" in value;

    return isInstance;
}

export function ReferralCodeValidationFromJSON(json: any): ReferralCodeValidation {
    return ReferralCodeValidationFromJSONTyped(json, false);
}

export function ReferralCodeValidationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferralCodeValidation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'referral_code': json['referral_code'],
    };
}

export function ReferralCodeValidationToJSON(value?: ReferralCodeValidation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'referral_code': value.referral_code,
    };
}

